import {
  StatusActiveIcon,
  StatusInactiveIcon,
} from '../icons/StatusIcons';
import type { StatusDropdownConfigMap } from '@/components/ui/status-dropdown';

export type InventoryStatus = 'active' | 'inactive';

export function createInventoryStatusDropdownConfig(
  labels?: Record<InventoryStatus, string>,
): StatusDropdownConfigMap<InventoryStatus> {
  const l = labels ?? { active: 'Active', inactive: 'Inactive' };

  return {
    active: {
      label: l.active,
      activeTextClassName: 'text-confirmed-green',
      inactiveTextClassName: 'text-grey',
      icon: (isActive) => (
        <StatusActiveIcon className={isActive ? 'text-confirmed-green' : 'text-grey'} />
      ),
    },
    inactive: {
      label: l.inactive,
      activeTextClassName: 'text-grey',
      inactiveTextClassName: 'text-grey',
      icon: () => <StatusInactiveIcon className="text-grey" />,
    },
  };
}
